import {
    faEdit,
    faMailBulk,
    faPlus,
    faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { useUserInfor } from "../../../../../../../Context/User";
import { ListarDocumentosTemplateController } from "../../../../../../../Controllers/Geral/GestaoDeCadastros/DocumentosTemplate/DocumentosTemplateControllers";
import { ListarEmailContaController } from "../../../../../../../Controllers/Geral/GestaoDeCadastros/EmailConta/EmailContaController";
import {
    DeletarEmailReceptivoController,
    ListarEmailReceptivoController,
} from "../../../../../../../Controllers/Geral/GestaoDeCadastros/EmailConta/EmailReceptivoController";
import { ListarCanalAtendimentoContoller } from "../../../../../../../Controllers/Geral/GestaoDeCadastros/TipoCanalAtendimento/TipoCanalAtendimentoController";
import {
    IDadosParaCadastroEmailReceptivo,
    IEmailReceptivo,
} from "../../../../../../../Interfaces/Geral/GestaoDeCadastro/Emailconta/EmailReceptivoInterface";
import ModalComponent from "../../../../../../Modais";
import { IComponentModal } from "../../../../../../Modais/IModalComponent";
import Table from "../../../../../../Table";
import CadastrarEditarEmailReceptivo from "./CadastrarEmailReceptivo";

export default function ConfiguracaoEmailReceptivo() {
    const modulos = useUserInfor().OrgInfor.MODULOS;

    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();
    const [lstEmailContaReceptivo, setLstEmailContaReceptivo] = useState<
        Array<IEmailReceptivo>
    >([]);
    const [loading, setLoading] = useState(false);

    const [dadosParaCadastro, setDadosParaCadastro] =
        useState<IDadosParaCadastroEmailReceptivo>({
            lstTipoCaso: [],
            lstTemplateDocumento: [],
            lstEmails: [],
            lstCanalAtendimento: [],
        });

    useEffect(() => {
        Promise.all([
            ListarEmailContaController(),
            ListarCanalAtendimentoContoller(),
            ListarDocumentosTemplateController(),
            setLoading(true),
        ])
            .then((res) => {
                const [lstEmails, lstCanalAtendimento, lstTemplateDocumento] =
                    res;
                setDadosParaCadastro({
                    lstEmails,
                    lstCanalAtendimento,
                    lstTemplateDocumento,
                    lstTipoCaso: modulos || [],
                });
            })
            .then(updateList);
    }, [modulos]);

    async function updateList() {
        return ListarEmailReceptivoController().then((res) => {
            setLoading(false);
            setLstEmailContaReceptivo(res);
        });
    }

    function RowTableEmail(cell: any, row: IEmailReceptivo) {
        return (
            <div className="rowCapysTR d-flex justify-content-between align-items-center">
                <div>
                    <label className="mb-1">{row.DS_EMAIL_CONTA}</label>

                    <div>
                        {row.DS_TAG_PROTOCOLO && (
                            <span className="label label-pill label-inline label-info">
                                {row.DS_TAG_PROTOCOLO}
                            </span>
                        )}
                    </div>
                </div>
                <div>
                    <div className="Button-Tools">
                        <button
                            className="btn btn-outline-primary font-weight-bold mr-2"
                            onClick={() => {
                                setShow(true);
                                setModal({
                                    Component: () =>
                                        CadastrarEditarEmailReceptivo({
                                            setShow,
                                            updateList,
                                            dadosParaCadastro,
                                            emailReceptivo: row,
                                        }),
                                    headerComponent: "Editar Email Receptivo",
                                    IconHeader: faMailBulk,
                                });
                            }}
                        >
                            <FontAwesomeIcon icon={faEdit} size="lg" /> Editar
                        </button>
                        <button
                            className="btn btn-outline-danger font-weight-bold mr-2"
                            onClick={() => {
                                Swal.fire({
                                    title: "Todos os emails na triagem vinculados a esse email receptivo serão excluidos. Deseja continuar com a exclusão?",
                                    icon: "info",
                                    buttonsStyling: false,
                                    confirmButtonText:
                                        "<i class='la la-check'></i> Sim!",
                                    showCancelButton: true,
                                    cancelButtonText:
                                        "<i class='la la-thumbs-down'></i> Não",
                                    customClass: {
                                        confirmButton:
                                            "btn btn-outline-success",
                                        cancelButton: "btn btn-default",
                                    },
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        DeletarEmailReceptivoController(
                                            row.ID_EMAIL_CONTA_CONFIG || 0
                                        ).then(() => {
                                            updateList();
                                        });
                                    }
                                });
                            }}
                        >
                            <FontAwesomeIcon icon={faTrash} size="lg" /> Excluir
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    const ColunsEmail = [
        {
            dataField: "DS_EMAIL_CONTA",
            text: "E-mail",
            formatter: RowTableEmail,
            sort: true,
        },
    ];

    return (
        <div>
            <div className="border-0 d-flex justify-content-between align-items-center p-0">
                <h5 className="card-title align-items-start flex-column m-0">
                    <span className="card-label font-weight-bolder text-dark">
                        Configuração de E-mail Receptivo
                    </span>
                </h5>
                <div className="card-toolbar">
                    <button
                        className="btn btn-success font-weight-bold mr-2"
                        onClick={() => {
                            setModal({
                                Component: () =>
                                    CadastrarEditarEmailReceptivo({
                                        setShow,
                                        updateList,
                                        dadosParaCadastro,
                                    }),
                                noFooter: true,
                                noHeader: true,
                            });
                            setShow(true);
                        }}
                    >
                        <FontAwesomeIcon
                            icon={faPlus}
                            size="lg"
                            className="mr-2"
                        />{" "}
                        Novo E-mail
                    </button>
                </div>
            </div>
            <div className="card-body p-0 mt-5">
                <div className="table-responsive-sm">
                    <Table
                        columns={ColunsEmail}
                        data={lstEmailContaReceptivo}
                        loading={loading}
                        keyField="ID_EMAIL_CONTA_CONFIG"
                    />
                </div>
            </div>
            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </div>
    );
}
